export default {"src":"/_next/static/media/drainage.117ef57e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};